export default __webpack_public_path__ + "static/media/Roboto-Bold.0c4c7fc6.woff2";